/**
* this is the Billing Page
*
* Created by Butterfly 07/09/2018
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import config from '../../config'
import moment from 'moment'
import { intlNumberFormatter, substitute } from '../../utility/utilities'
// action import
import { ActionCreator } from '../../actions/'

// component import
import SimpleLoader from '../../components/SimpleLoader/'


// style import
import './style.scss'


class Billing extends Component {

    componentDidMount() {
        const { getBillingData } = this.props
        getBillingData();

    }

    getBillingDownloadURL(id){
            const invoiceDowload = substitute(config.endpoints.billingDownloadURL, {id: id})
            return invoiceDowload;
    }

    renderBillingListHeader(){
        return(
                <div className="billing__invoices__list header">
                    <span className="billing__invoices__list__date">Date</span>
                    <span className="billing__invoices__list__desc">Description</span>
                    <span className="billing__invoices__list__amount">Amount</span>
                    <span className="billing__invoices__list__status">Status</span>
                    <span className="billing__invoices__list__download">Download</span>
                </div>
        )
    }

    render() {
        const { billingData, billingloading } = this.props

        const billingList = billingData.map((bill, index) =>
            <div key={ index } className="billing__invoices__list">
                <span className="billing__invoices__list__date">{ moment(bill.debit_date).format("DD MMM YY") }</span>
                <span className="billing__invoices__list__desc">Selfmade Direct Debit</span>
                <span className="billing__invoices__list__amount">{ intlNumberFormatter('en-AU', 'currency', 'AUD', parseFloat(bill.payment_amount)) }</span>

                {/* Payment Status: https://www.getpayments.com/docs/#getpayments */}
                { bill.payment_status === "S" &&
                    <span className="billing__invoices__list__status">Successful</span>
                }
                { bill.payment_status === "P" &&
                    <span className="billing__invoices__list__status">Pending</span>
                }
                { bill.payment_status === "W" &&
                    <span className="billing__invoices__list__status">Waiting</span>
                }
                { (bill.payment_status === "D" || bill.payment_status === "F")  &&
                    <span className="billing__invoices__list__status">Fail</span>
                }

                <span className="billing__invoices__list__download">
                { bill.payment_status === "S" &&
                    <a className="app-button app-button--small app-button--blue" target="_blank" href={ this.getBillingDownloadURL(index) }>Download</a>
                }
                </span>
            </div>
        );

        return(
            <div className="billing main-wrapper" >

                <div className="main-container">

                    <div className="page-title">BILLING</div>

                    <div className="billing-container">

                        {/* render content */}
                        <div className="billing__payment-information">
                            <div className="billing__payment-information__header">
                                Payment method
                            </div>
                            <div className="billing__payment-information_body-text">
                                See our <a rel="noopener noreferrer" target="_blank" href="http://www.selfmade.com.au/pricing">fees</a> page to find out more about initial setup costs and ongoing maintenance of your SMSF.
                                Initial payment will be taken from your account 30 days from registration.
                            </div>
                        </div>
                        <div className="billing__invoices" >
                        { billingloading === false &&
                            <div className="billing__invoices__wrapper" >
                                { billingList.length > 0 && this.renderBillingListHeader() }

                                { billingList }

                                { billingList.length === 0 &&
                                    <div> There are currently no invoices avaliable. </div>
                                }
                            </div>
                        }
                        </div>


                        {/* render loader*/}
                         <SimpleLoader
                             num={ 3 }
                             show={ billingloading }
                             title="Please wait while we fetch the invoices."
                         />

                    </div>
                </div>
            </div>
        )

    }

}

// define the prop types
Billing.propTypes = {
    billingData: PropTypes.array,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        billingData: state.billingState.data,
        billingloading : state.billingState.billingloading,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getBillingData: action.getBillingData,
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Billing)



// WEBPACK FOOTER //
// ./src/pages/Billing/index.js